"use client"

import {connect} from "react-redux";
import { useState, useEffect } from "react"
import { motion } from "framer-motion"
import FlowItem from "./FlowItem";
import { selectAuthState } from "../../../../store/selectors/authSelectors";

function FlowList({ onFlowSelect, flows, error, loading }) {
  if (loading) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
      >
        {[1, 2, 3, 4, 5, 6].map((item) => (
          <FlowItem key={item} loading={true} />
        ))}
      </motion.div>
    );
  }

  if (error) {
    return (
      <div className="p-4 text-center">
        <h3 className="text-xl font-bold text-red-500 mb-2">Error</h3>
        <p className="text-slate-600 dark:text-slate-300">{error}</p>
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
    >
      {flows.map((flow) => (
        <FlowItem
          key={flow.id}
          flow={flow}
          onClick={() => onFlowSelect(flow)}
        />
      ))}
    </motion.div>
  );
}

export default connect(selectAuthState)(FlowList);